var LOCALE = window.LOCALE || {};
LOCALE.fr = {
    ERROR: 'Oops!',
    ERROR_UNDEFINED: 'Erreur inconnue',
    ERROR_APP: 'Une erreur est survenue. Veuillez actualiser la page pour continuer. Si l\'erreur persiste, contactez le support. Nous nous excusons pour la gêne occasionnée.',
    ERROR_REQUIRED_FP_VER: 'Pour continuer, vous devez activer votre lecteur Adobe Flash sur cette page.',
    ACTION_UPDATE_FP: 'Autoriser',
    PLEASE_RELOAD: 'Veuillez rafraîchir la page',
    ACTION_RELOAD: 'Rafraîchir',
    GAME: 'Jouer',
    SUPPORT: 'Support',
    COMMUNITY: 'Communauté',
    YOUR_ID: 'Votre identifiant',
    LOADING: 'Chargement',
    GAME_NAME: 'Seigneurs de l\'Arène',
    ERROR_SOCIAL: 'Erreur de réseau social',
    LIKE_BUTTON_TITLE: 'Seigneurs de l\'Arène',
    LIKE_BUTTON_DESCRIPTION: 'Jeu Seigneurs de l\'Arène',
    FAQ: 'FAQ',
    ACTION_INVITE: 'Inviter',
    SIG_SERVER_22: 'Le jeu est temporairement indisponible en raison de la maintenance du serveur. Veuillez réessayer plus tard.',
    INVITE_MESSAGE: 'Combattez avec moi dans ce nouveau jeu de stratégie. De grandes batailles nous attendent!',
    INVITE_TITLE: 'Seigneurs de l\'Arène!',
    FP_DIALOG_MESSAGE1: 'Pour démarrer le jeu, vous devez lancer le lecteur Flash',
    FP_DIALOG_ENABLE1: 'Si la fenêtre n\'apparaît pas, ouvrez ce lien dans un nouvel onglet:',
    FP_DIALOG_ENABLE2: 'chrome: // paramètres / contenu / flash',
    FP_DIALOG_ENABLE3: 'Désactivez le paramètre "Empêcher les sites de démarrer Flash", puis revenez au jeu et cliquez sur "Lancer!" encore une fois.',
    FP_DIALOG_RUN: 'Lancer!',
    FP_DIALOG_ALLOW: 'Cliquez sur "Autoriser" dans la nouvelle fenêtre de dialogue qui apparaîtra.',
    SWF_PLAYER_FALLBACK_NOTICE: 'Si vous rencontrez des problèmes pour charger le jeu, essayez de passer à la version Flash.',
    SWITCH_TO_SWF_PLAYER: 'Version Flash',
    SWITCH_TO_HTML_PLAYER: 'Version HTML',
    REGISTER_DIALOG_MESSAGE: '',
    REGISTER_DIALOG_RUN: '',
    RELOAD_AFTER_LOGIN: ''
};